export const DEFAULT_POSTING_DATE = 'DEFAULT_POSTING_DATE';
export const CHECK_POSTING_DATE = 'CHECK_POSTING_DATE';
export const FINANCIAL_POSTINGS_DEFAULT_DATE = 'FINANCIAL_POSTINGS_DEFAULT_DATE';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const FISCALYEAR_DATA_SUCCESS = 'FISCALYEAR_DATA_SUCCESS';
export const DROP_DOWN_SUCCESS = 'DROP_DOWN_SUCCESS';
export const DROP_DOWN_FIELD_SUCCESS = 'DROP_DOWN_FIELD_SUCCESS';
